import React, { FormEvent, useEffect, useState } from "react";
import Statics from "./components/Statics";
import style from "./index.module.scss";
import { Button, Input } from "antd";

interface ButtonsProps {
    filterObj: { status: string; text: string }; //当前选中状态和查询字符
    allCounts: number; //总数
    noJudgeCounts: number; //未批阅
    judgeCounts: number; //已批阅
    noJoinInCounts: number; //未参与
    onChange: (val: { status: string; text: string }) => void; //点击切换状态
}

export default function Buttons({
    filterObj,
    allCounts,
    noJudgeCounts,
    judgeCounts,
    noJoinInCounts,
    onChange
}: ButtonsProps) {
    const [text, setText] = useState("");
    const [filterStatus, setFilterStatus] = useState(filterObj.status);

    useEffect(() => {
        setText(filterObj.text);
    }, [filterObj]);

    useEffect(() => {
        onChange({ status: filterStatus, text: "" });
    }, [filterStatus]);

    function onConfirmSearch(e: FormEvent) {
        e.preventDefault();
        onChange({ status: filterStatus, text: text });
    }
    return (
        <div className={style.root}>
            <Statics
                current={filterObj.status}
                onChange={setFilterStatus}
                allCounts={allCounts}
                noJudgeCounts={noJudgeCounts}
                judgeCounts={judgeCounts}
                noJoinInCounts={noJoinInCounts}
            />

            <form className={style.filter} onSubmit={onConfirmSearch}>
                <Input
                    className={style.input}
                    placeholder="请输入小组名称及关键词"
                    value={text}
                    onChange={e => setText(e.target.value)}
                />
                <Button htmlType="submit" type="primary" icon="search">
                    查询
                </Button>
            </form>
        </div>
    );
}
